const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M16.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-13 13A1 1 0 0 1 8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l13-13ZM14 7.414l-9 9V19h2.586l9-9L14 7.414Zm2-2L14.414 7l2.293 2.293L18.414 7.586 16 5.414Z"
      />
    </svg>
  );
};

export default EditIcon;
